import { Navigate, useLocation } from 'react-router-dom'

/**
 * Редирект со старого адреса на тот же путь под «/lk».
 *
 * До появления лендинга личный кабинет жил в корне домена, и наружу ушли
 * ссылки на главы Библии (отправка стихов в мессенджер — основной канал,
 * по которому о сервисе узнают, см. useVerseSelection), закладки браузера
 * и ярлык установленного PWA. Ломать их нельзя, поэтому старые адреса
 * не удалены, а переадресуются вместе с «?query» и «#hash» — якорь стиха
 * лежит именно в hash.
 */
export function LegacyRedirect() {
  const { pathname, search, hash } = useLocation()
  return <Navigate to={`/lk${pathname}${search}${hash}`} replace />
}
